import type { Coord } from "@dailywars/core/engine";

import { cancelConfirmAttack } from "#/game/selection/transitions";
import type { StoreState } from "#/game/store/types";

import { canAcceptTileSelect, makeTileSelectContext } from "./tileSelectContext";
import { handleNoneOrEnemyInspect, trySelectDifferentOwnUnit } from "./tileSelectNoneInspect";
import {
  handleBuildingMode,
  handleMovePreviewMode,
  handleTransportUnloadMode,
} from "./tileSelectPreviewAndBuilding";
import { handleUnitMode } from "./tileSelectUnitMode";

export function handleTileSelect(state: StoreState, tile: Coord): StoreState {
  if (state.selection.mode === "confirm-attack") {
    return cancelConfirmAttack(state);
  }

  if (!canAcceptTileSelect(state)) return state;

  const ctx = makeTileSelectContext(state, tile);
  const s = ctx.state;
  const selection = s.selection;

  if (selection.mode === "none" || selection.mode === "enemy-inspect") {
    return handleNoneOrEnemyInspect(ctx);
  }

  const switched = trySelectDifferentOwnUnit(ctx);
  if (switched !== undefined) return switched;

  switch (selection.mode) {
    case "unit":
      return handleUnitMode(ctx, selection);
    case "move-preview":
      return handleMovePreviewMode(ctx, selection);
    case "transport-unload":
      return handleTransportUnloadMode(ctx, selection);
    case "building":
      return handleBuildingMode(ctx, selection);
    default:
      return s;
  }
}
